import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSnowflake,
  faTemperatureArrowDown,
  faJar,
} from "@fortawesome/free-solid-svg-icons";

import "./SimpleProductCard.css";

const SimpleProductCard = ({ item }) => {
  const getTempIcon = () => {
    const temp = item.temperature[0];
    if (temp === "F") return faSnowflake;
    if (temp === "R") return faTemperatureArrowDown;
    return faJar;
  };

  const getTempLabel = () => {
    const temp = item.temperature[0];
    if (temp === "F") return "Frozen";
    if (temp === "R") return "Refrigerated";
    return "Dry";
  };

  return (
    <div className="simple-product-card">
      <div className="simple-card-image-container">
        <img
          src={item.thumbnailUrl || item.thumbnail}
          className="simple-card-image"
          alt={item.description}
        />
        <div className="simple-temp-badge">
          <FontAwesomeIcon icon={getTempIcon()} title={getTempLabel()} />
        </div>
      </div>
      <div className="simple-card-content">
        <div className="simple-card-price">
          <p className="product-price">{`${item.unitCount} ${
            item.unitLabel === "lb." ? "lb." : ""
          } for $${Number.parseFloat(item.casePrice / 100).toFixed(2)}`}</p>
        </div>
        <p className="simple-card-description">
          {item.description.length > 50
            ? item.description.substring(0, 50) + "..."
            : item.description}
        </p>
        <p className="simple-card-size">{item.unitSize}</p>
      </div>
    </div>
  );
};

export default SimpleProductCard;
